module.exports = "<p>\r\n  rxjs works!\r\n</p>\r\n"